/**
 * 获取窗口的宽和高兼容
 */
function clientDetail(){
  const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  return{
    h:height,
    w:width
  }
}
export default clientDetail;


// WEBPACK FOOTER //
// ./src/common/js/utils/clientDetail.js